import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const WEEK_VIDEO_REPORT_ID = `week${VIDEO_CAMPAIGN_SUFFIX}`;
